module.exports = __webpack_public_path__ + "media/FIVEx_tutorial_5.7184c9ba.mp4";